<template>
  <div class="footer">
    <div class="footer-small-box"></div>
    <div class="footer__header flex mw9 center" v-if="$route.name !== 'requests' && $route.name !== 'search'">
      <div class="footer__item footer__item--first">
        <p class="ma0">{{ $t('cTA') }}</p>
      </div>

      <div class="footer__item-wrapper">
        <div class="footer__item footer__item--second">
          <button class="footer__item__link" @click="showPhoneModal">
            <h4 class="text">{{ $t('callUs') }}</h4>
          </button>
          <transition name="fade">
            <div
                    v-if="isOpenPhoneModal"
                    class="footer__item__modal"
                    @mouseover="isHovering"
                    @mouseleave="notHovering"
                    v-on:blur="inputBlur"
            >
              <span class="footer__modal-exit-icon" @click="isOpenPhoneModal = !isOpenPhoneModal">&#88;</span>
              <div v-if="isPriority" class="mt2 mb4">
                <h2 class="footer__modal-title">{{ $t('callUs') }}</h2>
                <a class="footer__modal-link db" :href="`tel:${localNumber}`">
                  <h2 class="footer__modal-link-text">+447492888981 {{ $t('callNumberTextUK') }}</h2>
                </a>
              </div>
            </div>
          </transition>
        </div>

        <div class="footer__item footer__item--third">
          <button class="footer__item__link" @click="showChatModal">
            <h4 class="text">{{ $t('startLiveChat') }}</h4>
          </button>
          <transition name="fade">
            <div
                    v-if="isOpenChatModal"
                    class="footer__item__modals"
                    @mouseover="isHovering"
                    @mouseleave="notHovering"
                    v-on:blur="inputBlur"
            >
              <span class="footer__modal-exit-icon" @click="isOpenChatModal = !isOpenChatModal">&#88;</span>
              <div v-if="isPriority" class="mt2 mb4">
                <h2 class="footer__modal-title">{{ $t('chatModalTitle') }}</h2>
                <h2 class="footer__modal-subtitle">{{ $t('chatModalSubTitle') }}</h2>
                <ul class="footer__modal-options">
                  <li class="footer__modal-option">
                    <router-link class="footer__modal-link"
                            :to="{name: 'article', hash:`#${$store.state.flowObject.variables.popularQuestions[0]}-${chatLinkOne.title.replace(/ /g, '-')}`}"
                    >{{$t('popQues1')}}</router-link>
                  </li>
                </ul>
                <h2 class="footer__modal-subtitle">{{ $t('chatModalSubTitleFooter') }}</h2>
                <div class="footer__modal-option">
                  <a @click="startChat" class="footer__modal-divnk">{{ $t('startChat') }}</a>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <div class="footer__body relative pt2 pb0">
      <div class="footer__body__inner center relative">
        <div v-html="$t('lsweepshcFooterText', { siteName: capitalizeSitename, termsLink: termsLink, privacyLink: privacyLink })"
        class="text mw8-l mt3 footer-text lh-copy pb2"></div>
      </div>
      <div class="mb4 ph4">
        <div class="justify-between white row-container footer-lower">
          <div>
            <ul class="list flex pa0 ma3 tracked-l fs-fix footer-links">
              <li>
                <router-link class="link" :to="{ name: 'home' }">{{ $t('support') }}</router-link>
              </li>
              <li>
                <a class="link" :href="aboutLink">{{ $t('aboutLink') }}</a>
              </li>
              <li>
                <router-link class="link" :to="{ name: 'requests' }">{{ $t('contact') }}</router-link>
              </li>
              <li>
                <a class="link" :href="loginLink">{{ $t('loginLinkText') }}</a>
              </li>
            </ul>
          </div>
          <div>
            <p
                    v-html="$t('footerCopyright', { siteName: capitalizeSitename, currentYear: currentYear })"
                    class="text fw6 tracked-l tc fs-fix copyright"
            ></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  trackPageClick,
  capitalize,
  getCountryCode,
  available_countries,
  high_priority_countries,
  low_priority_countries,
  getStorage,
  replaceMaHcLoginSupportContent,
  getSpecificArticleFromStore
} from '@/utils/common';
// TODO:
export default {
  data() {
    return {
      phoneModalVisible: false,
      isOpenPhoneModal: false,
      isOpenChatModal: false,
      hovering: false,
      localNumberText: null,
      isTollFree: false,
      isPriority: false,
    };
  },
  created() {
    getCountryCode();
    this.getLocalNumber();
    replaceMaHcLoginSupportContent();
  },
  computed: {
    siteName() {
      return this.$store.state.siteDetails.site_name;
    },
    aboutLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/about`;
    },
    contactLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/contact`;
    },
    loginLink() {
      return `https://${this.$store.state.siteDetails.domain_name}/login`;
    },
    termsLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/terms`;
    },
    privacyLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/policy`;
    },
    usCanadaNumber() {
      return this.$store.state.siteDetails.support_number_us_canada;
    },
    capitalizeSitename() {
      return capitalize(this.siteName);
    },
    internationalNumber() {
      return this.$store.state.siteDetails.support_number_us_canada;
    },
    localNumber() {
      this.localNumberText = this.getLocalNumber();
      return this.localNumberText;
    },
    currentYear() {
      return new Date().getFullYear();
    },
    chatLinkOne() {
      const question = getSpecificArticleFromStore(this.$store.state.flowObject.variables.popularQuestions[0]);
      return question || { title: '' };
    },
    chatLinkTwo() {
      const question = getSpecificArticleFromStore(this.$store.state.flowObject.variables.popularQuestions[1]);
      return question || { title: '' };
    },
    chatLinkThree() {
      return `https://members.${this.$store.state.siteDetails.domain_name}/account/recovery`;
    },
  },
  methods: {
    startChat() {
      this.$gtm.dataLayer().push({
        event: 'Load Chatbot'
      });
      this.showChatModal();
    },
    trackPageClick,
    showPhoneModal() {
      this.isOpenPhoneModal = !this.isOpenPhoneModal;
      if (this.isOpenChatModal) {
        this.isOpenChatModal = !this.isOpenChatModal;
      }
    },
    showChatModal() {
      this.isOpenChatModal = !this.isOpenChatModal;
      if (this.isOpenPhoneModal) {
        this.isOpenPhoneModal = !this.isOpenPhoneModal;
      }
    },
    inputBlur() {
      if (!this.hovering) {
        this.isOpenPhoneModal = false;
      }
    },
    isHovering() {
      this.hovering = true;
    },
    notHovering() {
      this.hovering = false;
    },
    getLocalNumber() {
      // getCountryCode();

      let localNumber;
      let storedCountryCode = localStorage.getItem('country_code');
      // console.log(`storedCountryCode is... ${storedCountryCode}`);

      const getAvailableCountryList = available_countries;
      // console.log(`getAvailableCountryList is... ${getAvailableCountryList}`);
      const getHighPriorityCountryList = high_priority_countries;
      // console.log(`getHighPriorityCountryList is... ${getHighPriorityCountryList}`);
      const getLowPriorityCountryList = low_priority_countries;
      // console.log(`getLowPriorityCountryList is... ${getLowPriorityCountryList}`);

      // conditional logic to 'hide' 'local' number by changing 'isPriority' state
      if (getLowPriorityCountryList.indexOf(storedCountryCode) > -1) {
        this.isPriority = false;
        // console.log(`- isPriority is... ${this.isPriority}`)
      } else {
        this.isPriority = true;
        // console.log(`+ isPriority is... ${this.isPriority}`)
      }

      // define strings to check for
      let tollFreeString = this.$store.state.siteDetails.corp_info[`${storedCountryCode}_toll_free_number`];
      let paidPhoneString = this.$store.state.siteDetails.corp_info[`${storedCountryCode}_phone_number`];

      if (tollFreeString) {
        // if there's a 'toll-free' number from corp,...

        // display 'toll-free number' for 'us', 'ca' & 'it'
        if (storedCountryCode === 'us' || storedCountryCode === 'ca' || storedCountryCode === 'it') {
          this.isTollFree = true;

          localNumber = this.$store.state.siteDetails.corp_info[`${storedCountryCode}_toll_free_number`];
          localStorage.setItem('local_number', localNumber);
          return localNumber;
        }
      } else if (paidPhoneString) {
        // else if there's a regular (paid) number from corp,...

        // display 'uk toll-free number' for 'ru'
        if (storedCountryCode === 'ru') {
          localNumber = this.$store.state.siteDetails.corp_info.uk_toll_free_number;
          localStorage.setItem('local_number', localNumber);
          return localNumber;

          // display 'local number' for all others
        } else {
          localNumber = this.$store.state.siteDetails.corp_info[`${storedCountryCode}_phone_number`];
          localStorage.setItem('local_number', localNumber);
          return localNumber;
        }
      } else {
        // if there's neither or a mis-match.

        // display 'uk toll-free number' for 'uk'... mapped to 'gb'
        if (storedCountryCode === 'gb' || storedCountryCode === 'ru') {
          localNumber = this.$store.state.siteDetails.corp_info.uk_toll_free_number;
          localStorage.setItem('local_number', localNumber);
          return localNumber;

          // display 'es' after mapping to 'gb'
        } else if (storedCountryCode === 'es') {
          localNumber = this.$store.state.siteDetails.corp_info.uk_toll_free_number;
          localStorage.setItem('local_number', localNumber);
          return localNumber;

          // if there's no number from corp, display international (non-changing) number
        } else {
          localNumber = this.$store.state.siteDetails.corp_info.us_toll_free_number;
          localStorage.setItem('local_number', localNumber);
          return localNumber;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';
  @import '@/styles/lsweepshc-design.scss';

  .footer-small-box {
    height: 10px;
    background: #19BA48 !important;
  }

  .roboto {
    font-family: Roboto, Helvetica, Arial, sans-serif;
  }
  .fs24 {
    font-size: 24px;
  }
  .fs14 {
    font-size: 14px;
  }
  .footer {
    h2 {
      font-family: Roboto, Helvetica, Arial, sans-serif;
    }
  }
  .light-blue {
    color: #99d8f7;
  }
  .footer__header {
    background: #ddd;
    //border-color: #b4b4b4;
    //border-width: 1px 0;
    //border-style: solid;
    padding: 0% 3% 0% 3%;
    min-height: 80px;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
  }
  .footer__modal-exit-icon {
      position: absolute;
      right: 10px;
      top: 8px;
      font-weight: 500;
      cursor: pointer;
  }
  .footer__item {
    font-family: Roboto, Helvetica, Arial, sans-serif;
    text-align: center;
    margin: 0;
    padding: 1rem 0 1rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    h4 {
      font-family: 'Montserrat';
      font-style: italic;
    }
  }
  .footer__item-wrapper {
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: flex-start;
    @media screen and (min-width: 542px) {
      display: flex;
      position: relative;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .footer__item--first {
    display: flex;
    font-size: 18px;
    align-self: flex-start;
  }
  .footer__item--second {
    flex-basis: 48%;
    padding-bottom: 0px;
    @media screen and (min-width: 641px) {
      flex-basis: auto;
    }
  }
  .footer__item--third {
    flex-basis: 48%;
    @media screen and (min-width: 641px) {
      flex-basis: auto;
    }
  }
  .footer__item__link {
    color: #736257;
    font-weight: 600;
    text-transform: uppercase;
    justify-content: center;
    align-items: baseline;
    display: flex;
    text-decoration: none;
    -webkit-appearance: none;
    background-color: #fff;
    cursor: pointer;
    text-align: left;
    border: 1px solid #b4b4b4;
    position: relative;
    width: 100%;
    .text {
      font-weight: 800;
      margin: 0;
      transition: 0.4s ease all;
      animation-delay: 0.6s;
      padding: 15px 0px;
      font-size: 1rem;
      text-align: center;
      width: 100%;
      @media screen and (min-width: 641px) {
        padding: 10px 20px;
        width: auto;
        font-size: 1rem;
      }
    }
    .icon {
      // margin-right: 0.5em;
      margin-right: 5px;
      polyline,
      path {
        stroke: $theme-highlight;
      }
    }
    &:hover {
      background-color: #3ab3ee;
      color: white;
    }
    &:focus {
      outline: -webkit-focus-ring-color auto 0px;
    }
  }
  .footer__modal-title {
    font-size: 1.6rem;
    font-weight: 700;
    color: #2b2b2b;
    text-align: start;
    padding: 0 20px 0 20px;
  }
  .footer__modal-subtitle {
    font-size: 1rem;
    font-weight: 400;
    color: #2b2b2b;
    text-align: start;
    padding: 0px 20px 10px 20px;
    &:last-of-type {
      padding: 0px 20px 0px 20px;
    }
  }
  .footer__modal-link {
    text-decoration: none;
  }
  .footer__modal-link-text {
    font-size: 1rem;
    list-style: none;
    width: 100%;
    min-height: 60px;
    background-color: #3ab3ee;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 1.2rem;
    font-weight: 400;
    transition: 0.4s ease all;
    animation-delay: 0.6s;
    margin-bottom: 10px;
    &:hover {
      background-color: rgba($color: #3ab3ee, $alpha: 0.7);
    }
  }
  .footer__modal-options {
    padding: 0;
  }
  .footer__modal-option {
    text-decoration: none;
    font-size: 1rem;
    list-style: none;
    width: 100%;
    position: relative;
    min-height: 40px;
    background-color: #fff;
    transition: 0.4s ease all;
    animation-delay: 0.6s;
    text-align: left;
    border-bottom: 2px solid #000;
    &:first-of-type {
      border-top: 2px solid #000;
    }
    &:nth-child(4) {
      border-top: 2px solid #000;
    }
    &:hover {
      background-color: #f7f3f3;
      &::after {
        transform: scale(1.5);
      }
    }
    &::after {
      content: '>';
      color: #3ab3ee;
      font-size: 20px;
      position: absolute;
      font-weight: 500;
      right: 10px;
      top: calc(50% - 15px);
      transition: 0.4s ease all;
    }
  }
  .footer__modal-option a {
    width: 100%;
    height: 100%;
    padding-left: 10px;
    color: #2a2a2a;
    font-size: 1rem;
    font-weight: 400;
    text-decoration: none;
    cursor: pointer;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .footer__body {
    background: #2a2a2a;
    padding: 1rem 0;
    line-height: 1rem;
    min-height: 180px;
    .list {
      font-size: 1.15rem;
      li {
        margin-right: 16px;
        .link {
          color: #fff;
          font-weight: 600;
        }
        .link:hover {
          color: lightgray;
          font-weight: 600;
        }
      }
    }
  }
  .footer__body__inner {
    max-width: 50rem;
    .text {
      font-size: 0.9em;
      color: #676767;
    }
    .link {
      color: $theme-highlight;
      text-decoration: underline;
    }
  }
  .footer__item__modal {
    position: absolute;
    background: #fff;
    padding: 8px 8px 8px 8px;
    width: 340px;
    border: 2px solid #000;
    border-radius: 6px;
    left: 0;
    bottom: 140px;
    box-shadow: rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px,
    rgba(17, 17, 26, 0.1) 0px 24px 80px;
    .link {
      color: $theme-highlight;
    }
    @media (min-width: 641px) {
      bottom: 90px;
    }
  }
  .footer__item__modals {
    position: absolute;
    background: #EEEDED;
    padding: 8px 0px 8px 0px;
    width: 340px;
    border: 2px solid #000;
    border-radius: 6px;
    right: 0%;
    bottom: 140px;
    box-shadow: rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px,
    rgba(17, 17, 26, 0.1) 0px 24px 80px;
    .link {
      color: $theme-highlight;
    }
    @media (min-width: 641px) {
      bottom: 90px;
    }
    @media (min-width: 1000px) {
      right: -30%;
    }
    @media (min-width: 1300px) {
      right: -50%;
    }
    @media (min-width: 1600px) {
      right: -70%;
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .powered-by-zendesk {
    font-size: 13px;
    font-family: Helvetica, Arial, sans-serif;
    color: #fff;
    width: auto !important;
    clear: both;
    text-align: right;
    padding: 0px 15px;
  }
  .powered-by-zendesk a {
    color: #fff;
    text-decoration: none;
  }
  .powered-by-zendesk svg {
    position: relative;
    display: inline-block;
    top: 3px;
    content: ' ';
    width: 15px;
    height: 15px;
    margin-right: 5px;
    fill: #a5a5a5;
  }
  .fs-fix {
    font-size: 13.6px !important;
  }
  .copyright {
    margin-right: 15px;
  }
  @media screen and (min-width: 542px) {
    .footer__item--second {
      padding: 1rem 0 1rem 0;
    }
  }
  @media (min-width: 641px) {
    .footer__header {
      padding: 0% 10% 0% 10%;
      max-width: none;
      flex-direction: row;
      .footer__item {
        padding: 0 0.5rem;
      }
    }
    .footer__item--first {
      display: flex;
      align-self: center;
    }
  }
  @media (max-width: 375px) {
    .footer__body {
      padding: 1rem 1rem 4rem 1rem;
      .list li {
        padding-top: 10px;
      }
    }
    .footer__body__inner {
      justify-content: center;
    }
    .copyright {
      margin-top: 40px;
      margin-right: 0px;
    }
    .tracked-l {
      letter-spacing: 0.1em;
    }
    .powered-by-zendesk {
      position: relative;
      top: 45px;
    }
    .ma3 {
      flex-wrap: wrap;
      padding: 8px;
      margin-top: 5px;
    }
  }
  @media (max-width: 425px) {
    .footer__body__inner {
      justify-content: center;
    }
    .copyright {
      margin-top: 30px;
      margin-right: 0px;
      padding: 0px 5px 20px 5px;
    }
    .tracked-l {
      letter-spacing: 0.1em;
    }
    .powered-by-zendesk {
      position: relative;
      top: 45px;
      padding-right: 0;
    }
    .ph4 {
      padding-left: 0;
      padding-right: 0;
    }
  }
  @media (max-width: 830px) {
    .footer-links {
      justify-content: center;
    }
  }
  @media (min-width: 830px) {
    .footer-lower {
      display: flex;
    }
  }
  @media (min-width: 375px) and (max-width: 768px) {
    .footer-text {
      padding-left: 16px;
      padding-right: 16px;
    }
  }
  @media (min-width: 375px) and (max-width: 425px) {
    .powered-by-zendesk {
      top: 0;
      padding: 0px 15px;
    }
  }
  @media (min-width: 768px) {
    .footer__body__inner {
      justify-content: center;
      width: 450px;
    }
    .footer__body {
      text-align: justify;
    }
    .copyright {
      margin: 35px 0 65px 0px;
      letter-spacing: 0.1em;
    }
    .footer__body ul {
      justify-content: center;
    }
  }
  @media (min-width: 1024px) {
    .footer__body__inner {
      margin-bottom: 72px;
      margin-top: 72px;
      justify-content: center;
      width: 750px;
    }
    .footer__body {
      text-align: justify;
    }
    .copyright {
      margin-top: 17px;
      margin-bottom: 0px;
      margin-right: 0px;
    }
  }
</style>
